module.exports = __webpack_public_path__ + "73cffe1ffd82f3fae2681d4b0dcb9206.png";